import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import NativeAd from "../NativeAd";
import BottomAdBar from "../BottomAdBar";
import CornerAds from "../CornerAds";
// Left-side skyscraper re-enabled at user's request despite the same-account
// ad-quality risk noted in BottomAdBar.jsx (scareware/click-hijack creatives
// seen in earlier testing). Right side and popunder/Social Bar stay off.

// Home renders its own <NativeAd/> inline after the hero, so it's skipped
// here to avoid a duplicate. Bare legal/policy pages skip it too — ads
// alongside required legal text are unusual and weren't asked for.
const NATIVE_AD_EXCLUDED_PATHS = [
  "/",
  "/privacy-policy",
  "/terms",
  "/disclaimer",
  "/cookie-policy",
];

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const showNativeAd = !NATIVE_AD_EXCLUDED_PATHS.includes(pathname);

  return (
    <>
      <Header />
      <main id="main">
        {showNativeAd && <NativeAd />}
        {children}
      </main>
      <Footer />
      <BottomAdBar />
      <CornerAds />
    </>
  );
}
